import { z } from "zod";

// Audit-fact events emitted by the daily operational sweep (cron). These mirror
// the report/alert summaries into the log; the user-facing notifications are a
// separate channel.
export const dailyReportGenerated = z.object({
  type: z.literal("DailyReportGenerated"),
  siteId: z.string().min(1),
  summary: z.record(z.string(), z.unknown()),
});

export const complianceAlertGenerated = z.object({
  type: z.literal("ComplianceAlertGenerated"),
  certificateId: z.string().min(1),
  workerId: z.string().min(1),
  workerName: z.string().nullable().optional(),
  certificateType: z.string(),
  expiryDate: z.string().nullable().optional(),
});

export const operationsEvents = [
  dailyReportGenerated,
  complianceAlertGenerated,
] as const;
